import React from 'react';

const COPY = {
  en: {
    assistive: 'Warning',
    message: 'Caps Lock is on.'
  },
  fr: {
    assistive: 'Attention',
    message: 'Verr. maj. est activée.'
  }
};

export default function CapsLockWarning({ show, language = 'en' }) {
  if (!show) return null;
  const text = COPY[language] || COPY.en;
  return (
    <div className="govuk-warning-text" role="status" aria-live="polite">
      <span className="govuk-warning-text__icon" aria-hidden="true">!</span>
      <strong className="govuk-warning-text__text">
        <span className="govuk-warning-text__assistive">{text.assistive}</span>
        {text.message}
      </strong>
    </div>
  );
}
